import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ArrowSortDesc = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.18253 10L12.0017 6.07831L15.8177 10H8.18253ZM11.4094 5.25322L7.24694 9.52739C6.71921 10.0697 7.09316 11 7.84107 11H16.1589C16.9068 11 17.2808 10.0697 16.7531 9.52739L12.5941 5.25322C12.2656 4.91559 11.7344 4.91559 11.4094 5.25322ZM16.1589 13H7.84107C7.09316 13 6.71921 13.9303 7.24694 14.4726L11.4094 18.7468C11.7344 19.0844 12.2656 19.0844 12.5941 18.7468L16.7531 14.4726C17.2808 13.9303 16.9068 13 16.1589 13Z"
    />
  </SvgIcon>
));

ArrowSortDesc.displayName = 'ArrowSortDesc';

export default ArrowSortDesc;
